import { Search } from "@mui/icons-material"
import { Box } from "@mui/material"
import { memo, useContext, useEffect, useState } from "react"
import { CondominiosContext } from "../../../Providers/CondominiosContext/CondominiosContext"
import PesquisarCond from "./PesquisarCond/PesquisarCond"

import {
    BoxPesquisaAlinhamento,
    BoxPesquisaIconSerach,
    BoxVerdePesquisa,
    DivLupaPesquisarCond,
    InputPesquisaCond
} from "./sxLupaPesquisarCond"
import { AtalhosContext } from "../../../Providers/AtalhosContext/AtalhosContext"

const LupaPesquisarCond = () => {
    const { condominios } = useContext(CondominiosContext)
    const { criarAtalho } = useContext(AtalhosContext)
    const [open, setOpen] = useState(false)

    const handleClickLupa = () => {
        let el = document.getElementById('lupa_pesq_cond')
        if (el.style.display == 'none') {
            const grid = document.getElementById('GridNumeroCond')
            const size = grid.offsetWidth
            el.style.right = `${size}px`
            el.style.display = 'flex'
            setOpen(true)
        } else {
            el.style.display = 'none'
            setOpen(false)
        }
    }
    useEffect(() => {
        criarAtalho('c', handleClickLupa)
    }, [])

    const handlePesquisaCond = (event) => {
        document.getElementById(`cond_${event.target.value}`).click()
        handleClickLupa()
    }

    return (
        <Box component='div' sx={DivLupaPesquisarCond} onClick={handleClickLupa}>
            <Box component='div' sx={BoxVerdePesquisa}>
                <Box component='div' sx={BoxPesquisaAlinhamento}>
                    <Search sx={BoxPesquisaIconSerach}/>
                    <Box component='span' style={{ fontSize: '10px' }}>Pesq</Box>
                </Box>
            </Box>
            <Box component='div' sx={InputPesquisaCond} id='lupa_pesq_cond' style={{ display: 'none' }}>
                {condominios.length > 1 &&
                    <PesquisarCond
                        placeHolder="Pesquisar Condomínio"
                        style={{ height: '100%', width: '100%' }}
                        options={condominios}
                        onChange={handlePesquisaCond}
                        name="id_central"
                        value="id_central"
                        label="nome"
                        open={open}
                    />
                }
            </Box>
        </Box>
    )
}

export default memo(LupaPesquisarCond)
